import { type Timeframe, TIMEFRAMES } from "@trader/shared/MarketData"
import { setTimeframe } from "./workspaceStore.ts"

export function TimeframePicker({ current }: { readonly current: Timeframe }) {
  return (
    <div className="button-group" role="group" aria-label="Timeframe">
      {TIMEFRAMES.map((timeframe) => (
        <button key={timeframe} type="button" aria-pressed={timeframe === current} onClick={() => setTimeframe(timeframe)}>
          {timeframe}
        </button>
      ))}
    </div>
  )
}
